var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sub-section" },
    [
      _c("Title", {
        attrs: {
          title: "Weitere Software",
          "completion-type": _vm.completionType
        },
        on: { edit: _vm.edit }
      }),
      _vm._v(" "),
      _c(
        "div",
        { class: { inline: _vm.isNone } },
        [
          _c("SelectedItems", {
            staticClass: "no-left-padding",
            attrs: {
              selected: _vm.selected,
              "characteristic-items": _vm.meta.skillSoftwareSpecial,
              "none-info":
                "Ich habe noch keine Erfahrung mit spezieller Software",
              styling: _vm.selectedItemsStyling,
              flat: ""
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }